<ph-dialog [open]="open" size="md" [heading]="copy.title" (ph-close)="closed.emit(null)">
    <div>{{ message }}</div>

    <ph-actions slot="footer" align="between">
        <ph-button variant="secondary" mode="filled" (click)="closed.emit(null)">{{ copy.cancelButton }}</ph-button>
        <ph-toolbar>
            <ph-button variant="secondary" mode="filled" (click)="closed.emit('choose-another')">{{ copy.secondaryButton }}</ph-button>
            <ph-button (click)="closed.emit('confirm')">{{ copy.confirmButton }}</ph-button>
        </ph-toolbar>
    </ph-actions>
</ph-dialog>
